import { useRef, useState } from "react"

const useLoadingState = () => {
    // Loading para mostrar que un proceso está cargando en tiempo real
    const [isLoading, setIsLoading] = useState(false)
    // Loading con retraso en tiempo para deshabilitar botones o lugares donde haya riesgo de hacer registros duplicados
    const [isLoadingDelayed, setIsLoadingDelayed] = useState(false)
    // Candado sincrono: el estado no se actualiza hasta el siguiente render, y una segunda llamada en ese hueco
    // (doble clic, huella + submit) lo leeria en false
    const isLoadingRef = useRef(false)

    const toggleIsLoading = ({ value = false, timeout = 500 }: { value: boolean; timeout?: number }) => {
        isLoadingRef.current = value
        setIsLoading(value)
        if (value) {
            return setIsLoadingDelayed(value)
        }
        // Retrasar la habilitacion para evitar duplicaciones
        setTimeout(() => {
            setIsLoadingDelayed(value)
        }, timeout)
    }

    // Devuelve false si ya hay un proceso en curso; si no, lo marca como iniciado
    const tryStartLoading = () => {
        if (isLoadingRef.current) {
            return false
        }
        toggleIsLoading({ value: true })
        return true
    }

    return { toggleIsLoading, tryStartLoading, isLoading, isLoadingDelayed, isLoadingRef }
}

export default useLoadingState
